module.exports = __webpack_public_path__ + "logo32.png?ab69be5c59919e18167dc575d4579b38";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo32.png
// module id = 40
// module chunks = 0 1